export const SWITCH_EXPORT_FILE_TYPE = 'SWITCH_EXPORT_FILE_TYPE'
export const SWITCH_EXPORT_ORIGIN_PKG = 'SWITCH_EXPORT_ORIGIN_PKG'

export const SWITCH_NEW_MENU_ITEM = 'SWITCH_NEW_MENU_ITEM'
